import { connect } from 'react-redux'
import OrderSummary from './view'

export default connect(null, {})(OrderSummary)
